import { checkPincode } from "https://www.nilkamalhomes.com/cdn/shop/t/824/assets/pincode-checker.js";

// Global State Management
const State = {
  isNavigating: false,
  mediaGallery: null,
};

/**
 * Initializes the Swiper sliders for the modular dining configurator sections.
 */
function initConfigurators() {
  document.querySelectorAll(".mySwiperModularDining").forEach((swiperEl) => {
    if (swiperEl.swiperInstance) swiperEl.swiperInstance.destroy(true, true);

    const wrapper = swiperEl.closest(".modular_dining_table_top_slider");
    const nextBtn = wrapper?.querySelector(".swiper-button-next-modular");
    const prevBtn = wrapper?.querySelector(".swiper-button-prev-modular");

    if (!nextBtn || !prevBtn) return;

    swiperEl.swiperInstance = new Swiper(swiperEl, {
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
      spaceBetween: 20,
      speed: 600,
      slidesPerView: 3.2,
      mousewheel: { forceToAxis: true },
      breakpoints: {
        768: { slidesPerView: 4.2 },
        1024: { slidesPerView: 5 },
      },
      on: {
        init: (s) => {
          const activeSlide = s.slides.find((slide) => slide.classList.contains("active"));
          if (activeSlide) s.slideTo(s.slides.indexOf(activeSlide), 400);
        },
      },
    });
  });
}

/**
 * Sets up click event listeners for variants with 'active' check to prevent redundant AJAX calls.
 */
function initClick() {
  document.querySelectorAll(".modular_dining_click").forEach((element) => {
    const newElement = element.cloneNode(true);
    element.parentNode?.replaceChild(newElement, element);

    newElement.addEventListener("click", function (e) {
      e.preventDefault();
      if (State.isNavigating) return;

      const parentSlide = this.closest(".swiper-slide");
      
      const isActive = this.classList.contains("active") || (parentSlide && parentSlide.classList.contains("active"));
      if (isActive) return;

      const url = this.getAttribute("href");
      if (!url || url === window.location.href) return;

      if (parentSlide) {
        parentSlide.classList.add("active");
      }

      // Loader dikhao sirf clicked item par
      const loader = this.querySelector(".click_loader");
      if (loader) {
        loader.classList.remove("hidden");
        loader.classList.add("block");
      }

      ajaxDataFetch(url, true);
    });
  });
}

/**
 * Fetches HTML from a URL and replaces the main content area without a full page reload.
 */
function ajaxDataFetch(url, shouldPushState = false) {
  if (State.isNavigating) return;
  State.isNavigating = true;

  if (shouldPushState) history.pushState({ pageUrl: url }, "", url);

  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error("Fetch failed");
      return response.text();
    })
    .then((htmlString) => {
      const doc = new DOMParser().parseFromString(htmlString, "text/html");
      const fetchedContent = doc.querySelector("#main-content");
      const currentContent = document.querySelector("#main-content");

      if (fetchedContent && currentContent) {
        cleanupInstances();
        currentContent.innerHTML = fetchedContent.innerHTML;

        onInit();
        initializeDynamicImages(currentContent);
        initRelatedProduct();
        new ModularDining();
      }
    })
    .catch((err) => console.error("AJAX Error:", err))
    .finally(() => {
      State.isNavigating = false;
    });
}

/**
 * Destroys active Swiper instances and clears global references to prepare for new content.
 */
function cleanupInstances() {
  document.querySelectorAll(".mySwiperModularDining").forEach((el) => {
    if (el.swiperInstance) {
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
    }
  });

  if (State.mediaGallery) {
    State.mediaGallery.thumbnail?.destroy(true, true);
    State.mediaGallery.main?.destroy(true, true);
    State.mediaGallery = null;
  }

  const galleryRoot = document.querySelector(".product__Slider__container");
  if (galleryRoot) galleryRoot.dataset.galleryInitialized = "false";
}

/**
 * Initializes or restores the user's pincode and triggers the availability check.
 */
function pincodeInitialize() {
  const savedPin = localStorage.getItem("pincode") || "400028";
  const inputField = document.querySelector(".nh__pincode__checker__input");

  if (inputField) inputField.value = savedPin;
  if (typeof checkPincode === "function") checkPincode(savedPin);
}

/**
 * Initializes the product media gallery with vertical thumbnails and image zoom functionality.
 */
function initMediaGallerySlider() {
  const galleryRoot = document.querySelector(".product__Slider__container");
  if (!galleryRoot || galleryRoot.dataset.galleryInitialized === "true") return;

  const thumbEl = document.querySelector(".thumbnail-slider");
  const mainEl = document.querySelector(".main-slider");
  if (!thumbEl || !mainEl) return;

  const thumbnailSlider = new Swiper(thumbEl, {
    direction: "vertical",
    slidesPerView: 5,
    spaceBetween: 10,
    navigation: { nextEl: ".thumbnail__slider__next", prevEl: ".thumbnail__slider__prev" },
    slideToClickedSlide: true,
  });

  const mainSlider = new Swiper(mainEl, {
    slidesPerView: 1,
    thumbs: { swiper: thumbnailSlider },
    on: {
      slideChange() {
        const counter = document.querySelector(".slide-counter .current");
        if (counter) counter.textContent = this.realIndex + 1;
      },
    },
  });

  // Image Zoom Logic
  document.querySelectorAll(".main-slider .swiper-slide").forEach((slide) => {
    const img = slide.querySelector("img");
    if (!img) return;
    slide.addEventListener("mousemove", (e) => {
      const rect = slide.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transform = `scale(2) translate(${-(x - 50) / 2}%, ${-(y - 50) / 2}%)`;
    });
    slide.addEventListener("mouseenter", () => (img.style.transition = "transform 0.2s ease-out"));
    slide.addEventListener("mouseleave", () => (img.style.transform = "scale(1) translate(0, 0)"));
  });

  State.mediaGallery = { thumbnail: thumbnailSlider, main: mainSlider };
  galleryRoot.dataset.galleryInitialized = "true";
}

/**
 * Force-loads data attributes into src/srcset for images and triggers lazy loading.
 */
function initializeDynamicImages(container) {
  if (!container) return;
  container.querySelectorAll("picture, img").forEach((el) => {
    const sources = el.tagName === "PICTURE" ? el.querySelectorAll("source, img") : [el];
    sources.forEach((s) => {
      if (s.dataset.srcset) s.srcset = s.dataset.srcset;
      if (s.dataset.src) s.src = s.dataset.src;
    });
  });

  if (typeof window.initLazyImages === "function") window.initLazyImages();
}

/**
 * Force-loads Related product.
 */
function initRelatedProduct() {
  let swiper = new Swiper(".mySwiperRelatedProduct", {
  slidesPerView: 1.5,
  spaceBetween: 20,
  freeMode: true,
    navigation: {
    nextEl: ".nh-next-rec",
    prevEl: ".nh-prev-rec",
  },
    mousewheel: {
      forceToAxis: true,
    },
  breakpoints: {
    640: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  });

  // Function to load the recommendations dynamically and reinitialize Swiper
  const loadRecommendations = (url) => {
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          // Reinitialize Swiper after dynamic content is loaded
          swiperRelatedProduct = new Swiper(".mySwiperRelatedProduct", {
  slidesPerView: 1.5,
  spaceBetween: 20,
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
    navigation: {
    nextEl: ".nh-next-rec",
    prevEl: ".nh-prev-rec",
  },
     mousewheel: {
      forceToAxis: true,
    },
  breakpoints: {
    640: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  });
        }
      })
      .catch(e => console.error(e));
  };

  // Handle dynamic content loading and reinitialize Swiper
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;
    loadRecommendations(url);
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);
}


function initPriceBreakup() {
   document.querySelectorAll(".actual__price").forEach(el => {
  
      // Get only the text node that contains the number
      let textNode = Array.from(el.childNodes).find(node => node.nodeType === 3);
  
      if (!textNode) return;
  
      let raw = textNode.textContent.replace(/[^\d]/g, "");
      if (!raw || isNaN(raw)) return;
  
      let formatted = Number(raw).toLocaleString("en-IN");
  
      // Replace ONLY the number text, not the SVG
      textNode.textContent = " " + formatted;
    });
}

/**
 * Main orchestrator function that runs all initialization logic for the page sections.
 */
function onInit() {
  initConfigurators();
  initClick();
  if (document.querySelector(".product__Slider__container")) initMediaGallerySlider();
  if (document.querySelector(".nh__pincode__checker__input")) pincodeInitialize();
}

// Global Event Listeners
window.onpopstate = (e) => {
  if (e.state?.pageUrl) ajaxDataFetch(e.state.pageUrl, false);
  else window.location.reload();
};

window.addEventListener("load", () => {
  if (!history.state) history.replaceState({ pageUrl: window.location.href }, "", window.location.href);
});

document.addEventListener("DOMContentLoaded", onInit);
document.addEventListener("shopify:section:load", onInit);